module.exports = __webpack_public_path__ + "static/img/Documentation.17dc498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Documentation.png
// module id = 0Eg9
// module chunks = 0